import { pslClient } from "@/common/http-common";
import { API_URL_REFRESH } from "@/constants/api.constants.js";

class SecurityService {
  refresh(config) {
    return pslClient.post(API_URL_REFRESH, null, config).then((res) => {
      return res.data;
    });
  }
}

export default new SecurityService();
